module.exports = __webpack_public_path__ + "img/14.4280e7cf.jpg";